var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"weather"},[_c('div',{staticClass:"temperature"},[_vm._v(_vm._s(_vm.weather.temperature)+"°C")]),_c('div',{staticClass:"type"},[_vm._v(_vm._s(_vm.weather.type))])])])}
var staticRenderFns = []

export { render, staticRenderFns }